import { Injectable, OnInit } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserConfigService } from '../services/userConfig.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { Mode } from '../form-guide/utility/enums/enums';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { PopupNotificationComponent } from '../request/popup-notification/popup-notification.component';
import { LoginService } from 'src/modules/login/services/login.service';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard implements CanActivate {

  private isLoggedIn: boolean = false;
  private baseUrl: string;
  private loginUrl: string = "";
  UnauthorizedUserMessage: string;
  UnauthorizedUserTitle: string;
  alertModalRef: BsModalRef;
  backLabelText: string;
  IsEKey2: Boolean;
  IsEKey: Boolean;


  constructor(private loginService: LoginService, private http: HttpClient, private router: Router, private userConfigService: UserConfigService, private appConfig: AppConfigService, private translate: TranslateService, private modalService: BsModalService,) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;
    this.IsEKey2 = JSON.parse(this.appConfig.getAppConfig().IsEKey2);
    this.IsEKey = JSON.parse(this.appConfig.getAppConfig().IsEKey);

    this.translate.get("Common-container.Messages.UnauthorizedUserMessage").subscribe(translatedValue => {
      this.UnauthorizedUserMessage = translatedValue;
    });
    this.translate.get("unauthorized-Container.Labels.Unauthorized").subscribe(translatedValue => {
      this.UnauthorizedUserTitle = translatedValue;
    });
    this.translate.get("unauthorized-Container.Labels.GoToLoginPage").subscribe(translatedValue => {
      this.backLabelText = translatedValue;
    });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let headers = new HttpHeaders();
    LoaderService.showLoader();
    headers = headers.append('Cache-Control', 'no-cache')
      .append('Pragma', 'no-cache')
      .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
      .append('If-Modified-Since', '0');
    return this.http.get(this.baseUrl + '/api/UserDataManager/CheckIfAccessTokenIsStillValid', {
      headers: headers
    }).pipe(map((response: IGetOperationResponse<boolean>) => {
      if (response && response.Result) {
        //LoaderService.hideLoader();
        this.isLoggedIn = true;
        return this.isLoggedIn;
      } else {
        LoaderService.hideLoader();
        localStorage.clear();
        sessionStorage.clear();
        let initialState;
        if (this.IsEKey) {
          initialState = {
            alertMode: Mode.Error,
            alertHeader: this.UnauthorizedUserTitle,
            alertMassage: this.UnauthorizedUserMessage,
            backLableText: this.backLabelText,
            enableNavigation: true,
            navigateOnExit: false,
            navigationURL: 'login/redirect',
            // afterClosingFunc: this.loginService.RedirectToLogin
          };
          this.alertModalRef = this.modalService.show(PopupNotificationComponent, {
            initialState,
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
          });
          this.alertModalRef.content.closeBtnName = 'Close';

        }
        else if (this.IsEKey2) {
          initialState = {
            alertMode: Mode.Error,
            alertHeader: this.UnauthorizedUserTitle,
            alertMassage: this.UnauthorizedUserMessage,
            backLableText: this.backLabelText,
            enableNavigation: true,
            navigateOnExit: false,
            navigationURL: 'login/email',
            // afterClosingFunc: this.loginService.RedirectToLogin
          };
          this.alertModalRef = this.modalService.show(PopupNotificationComponent, {
            initialState,
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
          });
          this.alertModalRef.content.closeBtnName = 'Close';

        }

        return false;
      }
    }), catchError(err => {
      LoaderService.hideLoader()
      return of(false);
    }));
  }
  path: import("@angular/router").ActivatedRouteSnapshot[]; route: import("@angular/router").ActivatedRouteSnapshot;

}
